import PolymerAxisView, {PolymerAxisViewOptions} from 'molbio/maps/linear/PolymerAxisView';
import Type from 'molbio/maps/Type';
import AaSequenceAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import * as vo from 'settings/visibility-options/VisibilityOptions';

interface AaSequenceAlignmentAxisViewOptions extends PolymerAxisViewOptions {
  tabstate: AaSequenceAlignmentTabState;
}

class AaSequenceAlignmentAxisView extends PolymerAxisView {
  override tabstate!: AaSequenceAlignmentTabState;

  static override initClass(): void {
    this.prototype.className = 'proteinAlignmentAxis';
    this.prototype.setting = vo.AA_SEQUENCE_AXIS.name;
  }

  override initialize(options: AaSequenceAlignmentAxisViewOptions): void {
    super.initialize(options);
    this.tabstate = options.tabstate;
  }

  override getStartIndex(): number {
    return 1;
  }

  getBasesType(): Type {
    return this.tabstate.getType();
  }

  override getPolymerLength(): number {
    return this.tabstate.getPolymerLength();
  }
}

AaSequenceAlignmentAxisView.initClass();

export default AaSequenceAlignmentAxisView;
